import { PayrollCompanyDto } from "./company-account.dto";
import { PaginatorInfo } from "./generic.dto";

type Department = {
  id: number;
  companyId: number;
  code: string;
  name: string;
  description: string;
  active: boolean;
  createdAt: Date;
  modifiedAt: Date | null;
}

export class CreateDepartmentDto {
  code!: string;
  name!: string;
  description!: string;
  active?: boolean;
}

export interface DepartmentDto extends Department {
  company?: PayrollCompanyDto;
}

export class UpdateDepartmentDto {
  code?: string;
  name?: string;
  description?: string;
  active?: boolean;
}

export class QueryDepartmentDto {
  active?: boolean;
  page?: number = 1;
  limit?: number;
  orderBy: DepartmentOrderBy = DepartmentOrderBy.CREATED_AT_ASC;
}

export enum DepartmentOrderBy {
  CREATED_AT_ASC = 'createdAt:asc',
  CREATED_AT_DESC = 'createdAt:desc',
  MODIFIED_AT_ASC = 'modifiedAt:asc',
  MODIFIED_AT_DESC = 'modifiedAt:desc',
  CODE_ASC = 'code:asc',
  CODE_DESC = 'code:desc',
  NAME_ASC = 'name:asc',
  NAME_DESC = 'name:desc',
}

export class SearchDepartmentDto {
  q?: string;
  companyId?: number;
  page: number = 1;
  limit?: number;
  orderBy: DepartmentOrderBy = DepartmentOrderBy.CREATED_AT_ASC;
}

export class UploadDepartmentResponse {
  successful!: {
    departmentId?: number;
    rowNumber?: number;
  }[];
  failed!: {
    rowNumber?: number;
    errors: {
      column: string;
      reason: string;
    }[]
  }[];
}

export interface QueryDepartmentNoPaginationDto extends Omit<QueryDepartmentDto, 'page' | 'limit'> {};

export interface DepartmentPaginator extends PaginatorInfo<DepartmentDto> {}

export class ExportDepartmentQueryDto {
  departmentCode?: boolean;
  departmentName?: boolean;
  description?: boolean;
  orderBy: DepartmentOrderBy = DepartmentOrderBy.CREATED_AT_ASC;
}